import type { ReactElement } from "react";
import { useUiStore } from "../state/uiStore";
import type { ToastVariant } from "../state/uiStore";
import { Icons } from "./Icons";

const VARIANT_PALETTE: Record<
  ToastVariant,
  { bg: string; icon: ReactElement }
> = {
  in: {
    bg: "var(--success)",
    icon: <Icons.check size={14} sw={2.6} />,
  },
  out: {
    bg: "var(--danger)",
    icon: <Icons.arrowOut size={14} sw={2.4} />,
  },
  pause: {
    bg: "var(--warning)",
    icon: <Icons.coffee size={14} sw={2} />,
  },
  info: {
    bg: "var(--brand)",
    icon: <Icons.bell size={14} sw={2} />,
  },
  error: {
    bg: "var(--danger)",
    icon: <Icons.warn size={14} sw={2} />,
  },
};

export function Toast() {
  const toasts = useUiStore((s) => s.toasts);
  const popToast = useUiStore((s) => s.popToast);

  // Toujours montée : une zone live insérée avec son premier message n'est
  // souvent pas annoncée.
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((t) => {
        const p = VARIANT_PALETTE[t.variant] ?? VARIANT_PALETTE.info;
        return (
          <div
            key={t.id}
            className="toast"
            role={t.variant === "error" ? "alert" : undefined}
          >
            <div className="ic" style={{ background: p.bg }}>
              {p.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{t.title}</div>
              {t.subtitle && (
                <div style={{ fontSize: 11.5, opacity: 0.8 }}>{t.subtitle}</div>
              )}
            </div>
            <button
              className="toast-close"
              onClick={() => popToast(t.id)}
              style={{
                background: "none",
                border: "none",
                color: "rgba(255,255,255,0.7)",
                cursor: "pointer",
                padding: 0,
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
              }}
              aria-label="Fermer"
            >
              <Icons.close size={16} sw={2} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
